module.exports = __webpack_public_path__ + "static/media/ManAsHumanBeing.96df702b.png";